import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModules } from '../context/ModulesContext';
import type { ModuleKey } from '../config/modules';
import LoadingState from './ui/LoadingState';

type RequireModuleProps = {
  module: ModuleKey;
  children: React.ReactNode;
};

const RequireModule: React.FC<RequireModuleProps> = ({ module, children }) => {
  const { isModuleEnabled, loading } = useModules();
  if (loading) return <LoadingState variant="page" />;
  if (!isModuleEnabled(module)) return <Navigate to="/admin/tesoreria" replace />;
  return <>{children}</>;
};

export default RequireModule;
